<template>
  <div>
    <NBar title="会员卡统计" :top="true"/>
    <nut-textinput class="my-input" v-model="search" placeholder="请输入微信昵称/会员ID/手机" :clearBtnPersonnal="true">
      <template v-slot:clearBtn>
        <nut-icon type="cross"></nut-icon>
      </template>
    </nut-textinput>
    <nut-cell :show-icon="true" title="会员卡统计" desc="请选择" @click-cell="goCountDetail()">
    </nut-cell>
    <nut-cell :show-icon="true" title="会员等级" @click.native="isVisible = true">
      <div slot="desc">
        <span style="color:rgb(0, 122, 255);">{{levelName}}</span>
      </div>
    </nut-cell>
    <nut-actionsheet :is-visible="isVisible" @close="isVisible = false">
      <div slot="custom">
        <div class="modal-header">
          <span class="btn" @click="isVisible = false">返回</span>
          <span class="text">请选择</span>
          <span class="btn" @click="ok()"> 确定</span>
        </div>
        <div class='level-item' v-for="(item,index) in list">
          <span class='title'>Lv{{index+1}}</span>
          <nut-radio v-model="levelNum" :label="index" @click="checkboxTap(index)"/>
        </div>
      </div>
    </nut-actionsheet>
    <div class="search">
      <div class="search-text">
        <span>累计充值</span>
        <div class="arrow">
          <span class="arrow-top"></span>
          <span class="arrow-down"></span>
        </div>
      </div>
      <div class="search-text">
        <span>余币数</span>
        <div class="arrow">
          <span class="arrow-top"></span>
          <span class="arrow-down"></span>
        </div>
      </div>
      <div class="search-text">
        <span>余额数</span>
        <div class="arrow">
          <span class="arrow-top"></span>
          <span class="arrow-down"></span>
        </div>
      </div>
    </div>
    <nut-infiniteloading @loadmore="onInfinite" :is-show-mod="true" :has-more="isHasMore" :is-loading="isLoading"
                         :threshold="200">
      <nut-cell v-for="(item,index) in list" :key="index" :show-icon="true" class="item" @click-cell="goDetail()">
          <span slot="title">
            <span class="name">美妍堂美容养生会所（林子）</span>
            <img class="label-img" :src='require("@/resource/img/device/pe-icon.648d0799.png")'/>
          </span>
        <span slot="sub-title">ID:434642432<span style="margin-left: 5px">女</span></span>
        <div slot="avatar">
          <img class="img-icon" :src='require("@/resource/img/device/crown_icon.b2bcf611.png")'/>
        </div>
        <div slot="desc" class="desc">
          <span class="text">累计充值246.99元</span>
          <span>余额<span class="price">49.04元</span>，余币<span class="price">49.04个</span></span>
        </div>
      </nut-cell>
    </nut-infiniteloading>
  </div>
</template>

<script>
export default {
  name: 'MemberCount',
  data () {
    return {
      search: '',
      list: [{
        name: '测试',
        phone: '18507316674',
        provinceName: '广东',
        cityName: '深圳',
        areaName: '宝安区',
        address: '新港同创汇'
      }, {
        name: '测试',
        phone: '18507316674',
        provinceName: '广东',
        cityName: '深圳',
        areaName: '宝安区',
        address: '新港同创汇'
      }, {
        name: '测试',
        phone: '18507316674',
        provinceName: '广东',
        cityName: '深圳',
        areaName: '宝安区',
        address: '新港同创汇'
      }, {
        name: '测试',
        phone: '18507316674',
        provinceName: '广东',
        cityName: '深圳',
        areaName: '宝安区',
        address: '新港同创汇'
      }, {
        name: '测试',
        phone: '18507316674',
        provinceName: '广东',
        cityName: '深圳',
        areaName: '宝安区',
        address: '新港同创汇'
      }, {
        name: '测试',
        phone: '18507316674',
        provinceName: '广东',
        cityName: '深圳',
        areaName: '宝安区',
        address: '新港同创汇'
      }, {
        name: '测试',
        phone: '18507316674',
        provinceName: '广东',
        cityName: '深圳',
        areaName: '宝安区',
        address: '新港同创汇'
      }],
      page: 2,
      num: 5,
      isHasMore: true,
      isLoading: false,
      isErr: false,
      timer: null,
      //是否显示动作面板
      isVisible: false,
      //级别id
      levelNum: 0,
      //级别名称
      levelName: '全部',
    }
  },
  methods: {
    goCountDetail () {
      this.$router.push('/device/MemberCountDetail')
    },
    goDetail () {
      this.$router.push('/device/MemberDetail')
    },
    onInfinite () {
      this.isLoading = true
      this.timer = setTimeout(() => {
        if (this.page <= 5) {
          let list = [{
            name: '测试',
            phone: '18507316674',
            provinceName: '广东',
            cityName: '深圳',
            areaName: '宝安区',
            address: '新港同创汇'
          }, {
            name: '测试',
            phone: '18507316674',
            provinceName: '广东',
            cityName: '深圳',
            areaName: '宝安区',
            address: '新港同创汇'
          }, {
            name: '测试',
            phone: '18507316674',
            provinceName: '广东',
            cityName: '深圳',
            areaName: '宝安区',
            address: '新港同创汇'
          }]
          for (let i in list) {
            this.list.push(list[i])
          }
          this.page = this.page + 1
        } else {
          this.isHasMore = false
        }
        this.isLoading = false
      }, 100)
    },
    //下单类型选择
    checkboxTap (value) {
      console.log(value)
      this.levelNum = value + 1
    },
    ok () {
      this.levelName = 'Lv' + this.levelNum
      this.isVisible = false
    }
  }
}
</script>

<style scoped>
  .search {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 40px;
    line-height: 40px;
    margin-top: 10px;
    background: #fff;
    border-bottom: 1px solid #e5e5e5;
  }

  .search .search-text {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex: 1;
  }

  .search .search-text .arrow {
    display: flex;
    flex-direction: column;
    margin-left: 5px;
  }

  .search .search-text .arrow .arrow-top {
    display: block;
    position: relative;
    top: 1px;
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-bottom-color: rgba(0, 0, 0, .2);
    margin-bottom: 4px;
  }

  .search .search-text .arrow .arrow-down {
    display: block;
    position: relative;
    top: -1px;
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-top-color: rgba(0, 0, 0, .2);
  }

  .item {
    padding: 10px;
  }

  .item .label-img {
    width: 38px;
    height: 16px;
  }

  .img-icon {
    width: 50px;
    height: 50px;
    margin-right: 10px;
  }

  .item .name {
    display: inline-block;
    white-space: nowrap;
    width: 105px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .item .desc {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-right: 5px;
  }

  .item .desc .text {
    color: #585858;
  }

  .item .desc .price {
    color: #ff9f00;
  }

  .modal-header {
    height: 50px;
    padding: 0 10px;
    line-height: 50px;
    background: #fff;
    border-bottom: 1px solid #e6e6e6;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .modal-header .btn {
    color: #1a87ff;
  }

  .level-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
    background: #ffffff;
    height: 40px;
    border-bottom: 1px #f9f9fb solid;
  }


  /deep/ .nut-textinput.my-input input {
    height: 36px;
    margin: 10px 15px;
    border-radius: 20px;
    padding-left: 40px;
    padding-right: 40px;
    background: url("data:image/svg+xml;charset=utf-8,%3Csvg version='1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M15.8 14.3l-3.3-3.1c1-1.1 1.6-2.6 1.6-4.1 0-3.6-3.1-6.6-7-6.6s-7 3-7 6.6c0 3.6 3.1 6.6 7 6.6 1.7 0 3.2-.6 4.4-1.5l3.3 3.1c.1.1.3.2.5.2s.4-.1.5-.2c.3-.3.3-.7 0-1zM1.5 7.1c0-2.9 2.5-5.2 5.6-5.2 3.1 0 5.6 2.3 5.6 5.2 0 2.9-2.5 5.2-5.6 5.2-3.2 0-5.6-2.3-5.6-5.2z' fill-rule='evenodd' clip-rule='evenodd' fill='%23999'/%3E%3C/svg%3E") no-repeat 10px;
    background-size: 18px;
  }

  >>> .nut-radio input:checked {
    background-color: #007aff;
    border-color: #007aff;
  }

  >>> .nut-radio input:after {
    background: #007aff;
  }
</style>



// WEBPACK FOOTER //
// src/components/device/userInfo/member/MemberCount.vue